import PropTypes from 'prop-types'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'
import React from 'react'
import useStyles from './styles'
import TonalButton from './tonal-button'

const renderIcon = IconComp => {
  if (!IconComp) {
    return null
  }

  const iconProps = {
    fontSize: 40,
    htmlColor: '#FFFFFF',
    style: { color: '#FFFFFF' },
  }

  if (typeof IconComp === 'function') {
    try {
      const rendered = IconComp()
      if (React.isValidElement(rendered)) {
        return React.cloneElement(rendered, {
          ...iconProps,
          style: { ...iconProps.style, ...rendered.props.style },
        })
      }
    } catch (error) {
      // IconComp is a component reference, not a render prop.
    }

    const Icon = IconComp
    return <Icon {...iconProps} />
  }

  const Icon = IconComp
  return <Icon {...iconProps} />
}

const EmptyPage = ({
  action,
  actionFn,
  IconComp,
  title,
  caption,
  captionSecondary,
  buttonText,
  buttonTo,
  removeButton,
  hideButtonMobile,
  buttonTextSecondary,
  actionFnSecondary,
  buttonToSecondary,
}) => {
  const styles = useStyles()
  const mobileHidden = hideButtonMobile ? styles.mobileHiddenButton : ''
  const hasSecondaryAction = Boolean(buttonTextSecondary)

  const primaryAction = (() => {
    if (removeButton) {
      return null
    }

    if (action) {
      return action
    }

    if (buttonTo) {
      return (
        <TonalButton to={buttonTo} className={mobileHidden}>
          {buttonText}
        </TonalButton>
      )
    }

    if (buttonText) {
      return (
        <TonalButton className={mobileHidden} onClick={actionFn}>
          {buttonText}
        </TonalButton>
      )
    }

    return null
  })()

  return (
    <Box className={styles.root}>
      {IconComp ? (
        <Box className={styles.iconCircle}>{renderIcon(IconComp)}</Box>
      ) : null}
      <Typography variant="h6" component="h2" className={styles.heading}>
        {title}
      </Typography>
      {caption ? (
        <Typography variant="body2" className={styles.caption}>
          {caption}
        </Typography>
      ) : null}
      {captionSecondary ? (
        <Typography variant="body2" className={styles.caption}>
          {captionSecondary}
        </Typography>
      ) : null}
      {primaryAction || hasSecondaryAction ? (
        <Box
          className={`${styles.actions} ${
            hasSecondaryAction ? styles.mobileBottomButtons : ''
          }`}
        >
          {primaryAction}
          {buttonTextSecondary ? (
            buttonToSecondary ? (
              <TonalButton to={buttonToSecondary}>
                {buttonTextSecondary}
              </TonalButton>
            ) : (
              <TonalButton onClick={actionFnSecondary}>
                {buttonTextSecondary}
              </TonalButton>
            )
          ) : null}
        </Box>
      ) : null}
    </Box>
  )
}

EmptyPage.propTypes = {
  action: PropTypes.node,
  actionFn: PropTypes.func,
  IconComp: PropTypes.oneOfType([PropTypes.func, PropTypes.elementType]),
  title: PropTypes.node,
  caption: PropTypes.node,
  captionSecondary: PropTypes.node,
  buttonText: PropTypes.node,
  buttonTo: PropTypes.string,
  removeButton: PropTypes.bool,
  hideButtonMobile: PropTypes.bool,
  buttonTextSecondary: PropTypes.string,
  actionFnSecondary: PropTypes.func,
  buttonToSecondary: PropTypes.string,
}

export default EmptyPage
